import {Collapse, Grid} from "@mui/material";
import {useCallback, useState} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {scChoices, scChoicesWithData, scChoicesWithoutData, unitChoices} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import MhdMarkerSymbolChoices from "../../atomicComponents/MhdMarkerSymbolChoices";
import MhdLineWidthChoices from "../../atomicComponents/MhdLineWidthChoices";
import MhdLineStyleChoices from "../../atomicComponents/MhdLineStyleChoices";
import MhdSolidColorWidget from "../../atomicComponents/MhdSolidColorWidget";
import {setAndUpdate} from "../../../utils/helpers";
import MhdSwitch from "../../atomicComponents/MhdSwitch";

const ObsWidget = ({data, mods, warn, errs, update, setter, shared}) => {
  const [customizeStyle, setCustomizeStyle] = useState(false)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <MhdSelect
          label="Spacecraft"
          value={data.sc_id}
          override={mods.sc_id}
          warning={warn.sc_id}
          error={errs.sc_id}
          onChange={useCallback((v) => setAndUpdate("sc_id", v, setter, update), [])}
          choices={scChoicesWithData}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label='CUSTOMIZE STYLE'
            value={customizeStyle}
            onChange={setCustomizeStyle}
        >
          <Collapse in={customizeStyle} >
            <Grid container spacing={1} pt={'2px'}>
              <Grid item xs={3}>
                <MhdSolidColorWidget
                  label='Line Color'
                  value={data.color}
                  onChange={useCallback((v) => setAndUpdate('color', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdMarkerSymbolChoices
                  label='Symbols'
                  value={data.marker_symbol}
                  onChange={useCallback((v) => setAndUpdate('marker_symbol', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdLineWidthChoices
                  label='Line Width'
                  value={data.line_width}
                  onChange={useCallback((v) => setAndUpdate('line_width', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdLineStyleChoices
                  label='Line Style'
                  value={data.line_style}
                  onChange={useCallback((v) => setAndUpdate('line_style', v, setter, update), [])}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
    </Grid>
  );
}

export default ObsWidget;